###
 * Save all data before submitting a form and prefill it if visited again
 * @package Syltaen
 * @author Stanley Lambot
 * @requires jQuery
###

import $ from "jquery"

# ==================================================
# > CLASS
# ==================================================
class PrefilledForm

    constructor: (@$form, @key, @nfModel) ->

        @key = "ap_" + @key

        # Try to prefill the form
        @prefill()

        # Store events
        @$form.find(".submit-wrap input, .submit-wrap button").click => @store()
        @$form.submit => @store()


    prefill: ->
        data = JSON.parse localStorage.getItem @key
        unless data then return false

        for k, v of data
            if k && v then @fillField k, v


    ###
    # Fill each field
    ###
    fillField: (id, value) ->
        $field = @$form.find("##{id}")

        # EXCEPTIONS
        if $field.hasClass "datepicker" then $field = $field.add $field.next()

        # TYPES
        switch $field.attr "type"
            when "checkbox", "radio"
                unless parseInt value then return false
                $field.prop "checked", true
            else
                $field.val value

        # CHANGE EVENT
        jQuery("##{id}").change()


    ###
    # Store each field value
    ###
    store: ->
        data = {}
        @$form.find("input, textarea, .ninja-forms-field").each (i, el) ->

            if $(el).attr("id") && $(el).val()

                switch $(el).attr "type"
                    when "checkbox", "radio"
                        if $(el).is(":checked") then val = 1 else val = 0
                    else
                        val = $(el).val()

                data[$(el).attr "id"] = val

        localStorage.setItem @key, JSON.stringify data
        # console.log "store", JSON.stringify data



# ==================================================
# > JQUERY METHOD
# ==================================================
$.fn.advancedPrefill = (key, nfModel = false) -> return new PrefilledForm $(this), key, nfModel


// WEBPACK FOOTER //
// ./scripts/tools/advancedPrefill.coffee